/**
 * API Configuration
 *
 * Centralized API endpoints and configuration.
 * Automatically detects environment:
 * - Production: Uses relative URLs (same origin)
 * - Development: Uses localhost:3001 or REACT_APP_API_URL
 */

const getApiBaseUrl = () => {
  // If environment variable is set, use it (for local mobile testing)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // In production, use relative URL (same origin)
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  // For local development
  return 'http://localhost:3001';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  generatePattern: `${API_BASE_URL}/api/generate-pattern`
};
